import './Footer.css';

// The copyright line under every page. It sits in the flow at the end
// of #main-wrapper, which layout.css lays out as a column, so it lands
// at the bottom of the screen on a short page and after the last row on
// a long one. It takes the same left margin as .content-body, so it is
// centred on the page column rather than on the window.
const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <p className="footer-copy">
        Copyright &copy; {year} SevenMentor Pvt. Ltd.
      </p>
    </footer>
  );
};

export default Footer;
